import EntityTable from './EntityTable';
import entityTableProjectionFn from './entityTableProjection';
import {EntityTableTabs} from './EntityTableTabs';
import {ColumnSelectionDropdown} from './ColumnSelectionDropdown';
import _ from 'lodash';

function tableExtraFilters(formatterSettings, preferences) {
    const currentTabIx = _.get(preferences, 'tabIx', 0);
    const globalFilter = formatterSettings.globalFilter;

    let tabFilter = _.get(formatterSettings, `tabs[${currentTabIx}].filter`);

    // we merge global and tab filter if provided.
    return [globalFilter, tabFilter].filter((f) => f).join('+');
}

export {EntityTable, EntityTableTabs, ColumnSelectionDropdown, entityTableProjectionFn, tableExtraFilters};
